import styled from 'styled-components';

export const Btn = styled.button`
	display: none;
	position: fixed;
	bottom: 20px;
	right: 50%;
	z-index: 99;
	font-size: 18px;
	border: 1px solid white;
	outline: none;
	background-color: #1e93ce;
	//background: rgba(133,13,56,0.5);
	color: white;
	cursor: pointer;
	padding: 15px;
	border-radius: 100%;
	width: 60px;
	//mix-blend-mode: multiply;
	opacity: 0.3;
`;
